import { Suspense, FC } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { privateRoutes } from 'config/privateRoutes';
import { usePermission } from 'hooks';
import Loader from 'components/ui/loader';
import { AppLayout } from './components/AppLayout';
import './app.scss';

const App: FC = () => {
  const { isEnabled } = usePermission();

  return (
    <AppLayout>
      <Switch>
        {privateRoutes.map((item, index) => {
          const { path, exact, params, component: PrivateComponent } = item;
          const enabled =
            !params.permissions || params.permissions?.some(isEnabled);

          return (
            <Route
              key={`${path}${index}`}
              exact={exact}
              path={path}
              render={(props) =>
                enabled ? (
                  <Suspense fallback={<Loader />}>
                    <PrivateComponent {...props} {...params} />
                  </Suspense>
                ) : (
                  <Redirect to='/' />
                )
              }
            />
          );
        })}
      </Switch>
    </AppLayout>
  );
};

export default App;
